<template>
  <div>
    <el-dialog :visible.sync="showForm" width="75%" top="5%" :show-close="false">
        <div key="form" v-loading="isLoading" element-loading-text="Enviando os dados, aguarde...">
          <el-row>
            <el-col :span="14">
              <h2 style="margin-top: 0; margin-bottom: 0;">Abertura de Empresa</h2>
              <h4 style="margin-top: 5px;">A partir das informações inseridas, poderá ser feito análise e planejamento para a abertura da sua empresa.</h4>
            </el-col>
            <el-col :span="10" class="el-dialog__footer" style="padding-top: 20px; padding-right: 0;">
              <el-button v-if="step !== 0" @click.prevent="goToStep(step - 1)">Passo anterior</el-button>
              <el-button v-if="totalSteps !== (step+1)" type="primary" @click.prevent="goToStep(step + 1)">Próximo passo</el-button>
              <el-button v-if="isValid" :disabled="!isValid" type="success" @click.prevent="sendForm">Enviar</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="7">
              <el-steps :space="75" :active="step" direction="vertical">
                <a @click.prevent="goToStep(0)" :style="getStepCursor(0)"><el-step title="Dados do Solicitante" description="Informações Pessoais" :status="steps[0].class"></el-step></a>
                <a @click.prevent="goToStep(1)" :style="getStepCursor(1)"><el-step title="Dados da Pessoa Jurídica" description="Nomes a escolher" :status="steps[1].class"></el-step></a>
                <a @click.prevent="goToStep(2)" :style="getStepCursor(2)"><el-step title="Endereço da Empresa" description="A ser constituida" :status="steps[2].class"></el-step></a>
                <a @click.prevent="goToStep(3)" :style="getStepCursor(3)"><el-step title="Atividades a ser exercida" description="Pela empresa a ser constituida" :status="steps[3].class"></el-step></a>
                <a @click.prevent="goToStep(4)" :style="getStepCursor(4)"><el-step title="Dados do Contrato Social" description="Informações sobre sócios" :status="steps[4].class"></el-step></a>
                <a @click.prevent="goToStep(5)" :style="getStepCursor(5)"><el-step title="Administração e Assinatura" description="Da empresa" :status="steps[5].class"></el-step></a>
                <a @click.prevent="goToStep(6)" :style="getStepCursor(6)"><el-step title="Outras Informações" description="Atendimento/tipo da empresa" :status="steps[6].class"></el-step></a>
                <a @click.prevent="goToStep(7)" :style="getStepCursor(7)"><el-step title="Documentos Necessários" description="Para abertura da empresa" :status="steps[7].class"></el-step></a>
              </el-steps>
            </el-col>

            <el-col :span="17">
              <solicitante :form="form.solicitante" v-show="step === 0" ref="step-0" /></solicitante>
              <pessoa-juridica :form="form.pessoaJuridica" v-show="step === 1" ref="step-1"></pessoa-juridica>
              <endereco-empresa :form="form.enderecoEmpresa" v-show="step === 2" ref="step-2" /></endereco-empresa>
              <atividades-ser-exercida :form="form.atividadesSerExercida" v-show="step === 3" ref="step-3" /></atividades-ser-exercida>
              <contrato-social :form="form.contratoSocial" v-show="step === 4" ref="step-4" /></contrato-social>
              <administracao-assinatura :form="form.administracaoAssinatura" v-show="step === 5" ref="step-5" /></administracao-assinatura>
              <diversos :form="form.diversos" v-show="step === 6" ref="step-6" /></diversos>
              <documentos-necessarios :form="form.documentosNecessarios" v-show="step === 7" ref="step-7" /></documentos-necessarios>
              <vue-recaptcha :sitekey="sitekey" @verify="verifyRecaptcha" @expired="recaptchaExpired" v-show="totalSteps === (step+1)" ref="_recaptcha"></vue-recaptcha>
            </el-col>
          </el-row>
        </div>

        <div key="buttons" slot="footer" class="dialog-footer" v-if="!isLoading">
          <el-button v-if="step !== 0" @click.prevent="goToStep(step - 1)">Passo anterior</el-button>
          <el-button v-if="totalSteps !== (step+1)" @click.prevent="goToStep(step + 1)" type="primary">Próximo passo</el-button>
          <el-button v-if="isValid" :disabled="!isValid" @click.prevent="sendForm" type="success">Enviar</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

import Solicitante from './ConstituicaoDeEmpresa/Solicitante'
import PessoaJuridica from './ConstituicaoDeEmpresa/PessoaJuridica'
import EnderecoEmpresa from './ConstituicaoDeEmpresa/EnderecoEmpresa'
import AtividadesSerExercida from './ConstituicaoDeEmpresa/AtividadesSerExercida'
import ContratoSocial from './ConstituicaoDeEmpresa/ContratoSocial'
import AdministracaoAssinatura from './ConstituicaoDeEmpresa/AdministracaoAssinatura'
import Diversos from './ConstituicaoDeEmpresa/Diversos'
import DocumentosNecessarios from './ConstituicaoDeEmpresa/DocumentosNecessarios'

export default {
  name: 'ConteudoConstituicaoDeEmpresa',

  components: {
    VueRecaptcha,
    Solicitante,
    PessoaJuridica,
    EnderecoEmpresa,
    AtividadesSerExercida,
    ContratoSocial,
    AdministracaoAssinatura,
    Diversos,
    DocumentosNecessarios
  },

  data () {
    return {
      sitekey: '6Ldv0esUAAAAAEfgh5OYk1RuQ3Is34jLR-HNL_G3',
      step: 0,
      steps: [
        { class: 'finish' },
        { class: 'wait' },
        { class: 'wait' },
        { class: 'wait' },
        { class: 'wait' },
        { class: 'wait' },
        { class: 'wait' },
        { class: 'wait' }
      ],
      isLoading: false,
      isReseting: false,
      form: {
        _recaptcha: {
          _response: '',
          _valid: false
        },
        solicitante: {
          nome: '',
          email: '',
          telefone: '',
          celular: '',
          cpf: '',
          _valid: false
        },
        pessoaJuridica: {
          nomeFantasia: '',
          razoesSociais: [
            { key: 1, nome: '' },
            { key: 2, nome: '' },
            { key: 3, nome: '' }
          ],
          _valid: false
        },
        enderecoEmpresa: {
          cep: '',
          logradouro: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          estado: '',
          _valid: false
        },
        atividadesSerExercida: {
          atividades: [
            { nome: '', descricao: '' }
          ],
          _valid: false
        },
        contratoSocial: {
          capitalSocial: '',
          socios: [
            {
              key: 1,
              nome: '',
              dataNascimento: '',
              estadoCivil: 'Solteiro',
              comunhaoDeBens: false,
              profissao: '',
              nacionalidade: '',
              naturalidade: '',
              rg: '',
              cpf: '',
              tituloEleitor: '',
              participacaoSocietaria: 0,
              retiraProLabore: false,
              socioAdministrador: true
            }
          ],
          _valid: false
        },
        diversos: {
          formaAtendimento: '',
          tipoEmpresa: '',
          outrasInformacoes: '',
          _valid: false
        },
        administracaoAssinatura: {
          tipo: 'Em conjunto',
          socios: [
            { key: 1, nome: '' }
          ],
          _valid: false
        },
        documentosNecessarios: {
          arquivos: [],
          _valid: false
        }
      },
      newForm: {
        _recaptcha: {
          _response: '',
          _valid: false
        },
        solicitante: {
          nome: 'Lorem Ipsum',
          email: 'lorem@ipsum.com',
          telefone: '(41) 3434-5592',
          celular: '(41) 98707-8479',
          cpf: '794.200.160-13',
          _valid: true
        },
        pessoaJuridica: {
          nomeFantasia: 'Nulla porta metus vel libero',
          razoesSociais: [
            { key: 1, nome: 'Mauris nec lorem sed risus' },
            { key: 2, nome: 'Suspendisse congue, ex sit amet' },
            { key: 3, nome: 'In congue purus eget feugiat' }
          ],
          _valid: true
        },
        enderecoEmpresa: {
          cep: '99999-999',
          logradouro: 'Donec non sodales magna',
          numero: '999',
          complemento: 'Tortor',
          bairro: 'Ornare vel',
          cidade: 'Sed et malesuada nisl',
          estado: 'Integer',
          _valid: true
        },
        atividadesSerExercida: {
          atividades: [
            { nome: 'Phasellus turpis ', descricao: 'Mauris laoreet aliquam consequat. Aliquam' }
          ],
          _valid: true
        },
        contratoSocial: {
          capitalSocial: '9.999,999',
          socios: [
            {
              key: 1,
              nome: 'Lorem Ipsum',
              dataNascimento: new Date(),
              estadoCivil: 'Solteiro',
              comunhaoDeBens: false,
              profissao: 'Duis',
              nacionalidade: 'Praesent',
              naturalidade: 'Curabitur',
              rg: '9.999.999-9',
              cpf: '794.200.160-13',
              tituloEleitor: '',
              participacaoSocietaria: 0,
              retiraProLabore: false,
              socioAdministrador: true
            }
          ],
          _valid: true
        },
        diversos: {
          formaAtendimento: 'Atendimento no Local',
          tipoEmpresa: 'Sociedade (Limitada)',
          outrasInformacoes: '',
          _valid: true
        },
        administracaoAssinatura: {
          tipo: 'Em conjunto',
          socios: [
            { key: 1, nome: 'Lorem Ipsum' }
          ],
          _valid: true
        },
        documentosNecessarios: {
          arquivos: [],
          _valid: false
        }
      },
      showForm: false
    }
  },

  computed: {
    totalSteps () { return this.steps.length },

    isValid () { return Object.values(this.form).every(component => component._valid) }
  },

  mounted () {
    this.$eventBus.$on('CONSTITUICAO_DE_EMPRESA', payload => {
      this.showForm = payload

      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)

      if (params.get('test') !== null) {
        Object.assign(this.$data.form, this.newForm)
        Object.assign(this.$data.steps, [ { class: 'success' }, { class: 'success' }, { class: 'success' }, { class: 'success' }, { class: 'success' }, { class: 'success' }, { class: 'success' } ])
      }
    })
  },

  watch: {
    form: {
      handler () {
        this.$nextTick(() => {
          if (!this.isReseting) {
            this.verifyValidation()
          } else {
            this.isReseting = false
          }
        })
      },
      deep: true
    }
  },

  methods: {
    changeStep (step) {
      this.step = step
    },

    updateStepClass (step, name) {
      this.steps[step].class = name
    },

    getStepCursor (step) {
      const style = this.step !== step ? 'pointer' : 'default'

      return `cursor: ${style}`
    },

    sendForm () {
      this.isLoading = true
      const hasFailure = this.steps.every((el, index) => this.verifyValidation(index) === false)

      if (!hasFailure) {
        this.$http.post('https://cdn.icnex.com/formularios5/?constituicao-de-empresa', this.form)
          .then(response => {
            this.$message.success('Enviado com sucesso! Aguarde nosso contato')

            this.$nextTick(() => {
              this.backToBeginSetup()
            })
          })
          .catch(response => {
            this.$message.error('Houve um erro! Por favor tente novamente mais tarde ou entre em contato.')

            this.$nextTick(() => {
              this.backToBeginSetup()
            })
          })
      }
    },

    verifyRecaptcha (recaptcha) {
      this.form._recaptcha = {
        _response: recaptcha,
        _valid: true
      }
    },

    recaptchaExpired () {
      this.$message({ type: 'error', message: 'A verificação expirou, por favor, faça novamente.' })

      this.form._recaptcha = {
        _response: '',
        _valid: false
      }
    },

    verifyValidation (step) {
      let activeStep = step || this.step

      this.$refs['step-' + activeStep].$refs['form']
        .validate((valid) => {
          this.$refs['step-' + activeStep].form._valid = valid

          if (valid) {
            this.updateStepClass(activeStep, 'success')
          } else {
            this.updateStepClass(activeStep, 'error')
          }

          return valid
        })
    },

    backToBeginSetup () {
      this.isReseting = true
      this.$refs._recaptcha.reset()
      this.steps.forEach((step, index) => {
        this.$refs[`step-${index}`].$refs['form'].resetFields()
        this.$nextTick(() => {
          if (index === 0) {
            step.class = 'finish'
          } else {
            step.class = 'wait'
          }
        })
      })
      this.isLoading = false
      this.showForm = false
      this.step = 0
    },

    goToStep (step) {
      if (step === this.step) {
        return
      }

      this.verifyValidation()

      this.updateStepClass(step, 'finish')

      this.changeStep(step)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ConteudoConstituicaoDeEmpresa.vue?321b0481